import * as React from "react";
const RedMailSvg = (props) => (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m19.321 7.261-2.505-2.09V2.205c0-.256-.223-.452-.484-.452h-3.645L11.225.533a2.326 2.326 0 0 0-2.97.005L6.793 1.753H3.1c-.256 0-.484.191-.484.452v3.012L.159 7.261A.46.46 0 0 0 0 7.62h.01v10.423a2.324 2.324 0 0 0 2.313 2.333h14.829a2.324 2.324 0 0 0 2.313-2.333V7.62h.01a.42.42 0 0 0-.154-.359m-2.505-.88 1.467 1.22-1.467 1.09zm-7.965-5.13a1.4 1.4 0 0 1 1.783.004l.59.498H8.25zM3.548 2.685h12.337v6.699l-5.302 3.948a1.42 1.42 0 0 1-1.681 0L3.548 9.347zm-.931 3.738v2.23l-1.42-1.057zm15.922 11.616a1.394 1.394 0 0 1-1.383 1.406H2.323a1.393 1.393 0 0 1-1.382-1.402V8.546l7.411 5.536c.824.61 1.951.61 2.775 0l7.412-5.536z"
      fill="currentColor"
    />
  </svg>
);
export default RedMailSvg;
